var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 14,
    viewBox: "0 0 16 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.1213 4.66667H11.82C11.8772 4.41116 11.9087 4.15061 11.9139 3.88889C11.9139 2.85749 11.5015 1.86834 10.7675 1.13903C10.0335 0.409721 9.03803 0 8 0C6.96197 0 5.96646 0.409721 5.23246 1.13903C4.49846 1.86834 4.08611 2.85749 4.08611 3.88889C4.09131 4.15061 4.12277 4.41116 4.18004 4.66667H1.87867L0 14H16L14.1213 4.66667ZM8 1.55556C8.62282 1.55556 9.22013 1.80139 9.66053 2.23897C10.1009 2.67656 10.3483 3.27005 10.3483 3.88889C10.3483 5.23444 8.95499 7.10889 8 8.19C7.04501 7.10889 5.65166 5.23444 5.65166 3.88889C5.65166 3.27005 5.89908 2.67656 6.33948 2.23897C6.77987 1.80139 7.37718 1.55556 8 1.55556ZM1.90998 12.4444L3.16243 6.22222H4.72798C5.4497 7.56783 6.3647 8.80188 7.44423 9.88556L8 10.4378L8.55577 9.88556C9.63253 8.80135 10.5449 7.56733 11.2642 6.22222H12.8297L14.0822 12.4444H1.90998Z",
    fill: "#CFCFCF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSite);
export default __webpack_public_path__ + "static/media/site.c6fcbb0e9d3e9c00b98c73b7a34b7755.svg";
export { ForwardRef as ReactComponent };